/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { SearchFacet } from './SearchFacet';
import {
    SearchFacetFromJSON,
    SearchFacetFromJSONTyped,
    SearchFacetToJSON,
    SearchFacetToJSONTyped,
} from './SearchFacet';
import type { SolrPersonReduced } from './SolrPersonReduced';
import {
    SolrPersonReducedFromJSON,
    SolrPersonReducedFromJSONTyped,
    SolrPersonReducedToJSON,
    SolrPersonReducedToJSONTyped,
} from './SolrPersonReduced';

/**
 * 
 * @export
 * @interface SolrResultSolrPersonReduced
 */
export interface SolrResultSolrPersonReduced  {
    /**
     * 
     * @type {number}
     * @memberof SolrResultSolrPersonReduced
     */
    numberResults?: number;
    /**
     * 
     * @type {Array<SolrPersonReduced>}
     * @memberof SolrResultSolrPersonReduced
     */
    results?: Array<SolrPersonReduced>;
    /**
     * 
     * @type {Array<SearchFacet>}
     * @memberof SolrResultSolrPersonReduced
     */
    facets?: Array<SearchFacet>;
}

/**
 * Check if a given object implements the SolrResultSolrPersonReduced interface.
 */
export function instanceOfSolrResultSolrPersonReduced(value: object): value is SolrResultSolrPersonReduced {
    return true;
}

export function SolrResultSolrPersonReducedFromJSON(json: any): SolrResultSolrPersonReduced {
    return SolrResultSolrPersonReducedFromJSONTyped(json, false);
}

export function SolrResultSolrPersonReducedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrResultSolrPersonReduced {
    if (json == null) {
        return json;
    }
    return {
        
                  'numberResults': json['numberResults'] == null ? undefined : json['numberResults'],
              'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(SolrPersonReducedFromJSON)),
              'facets': json['facets'] == null ? undefined : ((json['facets'] as Array<any>).map(SearchFacetFromJSON)),
    };
}

export function SolrResultSolrPersonReducedToJSON(json: any): SolrResultSolrPersonReduced {
    return SolrResultSolrPersonReducedToJSONTyped(json, false);
}

export function SolrResultSolrPersonReducedToJSONTyped(value?: SolrResultSolrPersonReduced | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'numberResults': value['numberResults'],
        'results': value['results'] == null? value['results']: (value['results'] as Array<any>).map(SolrPersonReducedToJSON),
        'facets': value['facets'] == null? value['facets']: (value['facets'] as Array<any>).map(SearchFacetToJSON),
    };
}


